import { render, staticRenderFns } from "./bkInventInsuranceModal.vue?vue&type=template&id=5fbf4017&scoped=true"
import script from "./bkInventInsuranceModal.vue?vue&type=script&lang=js"
export * from "./bkInventInsuranceModal.vue?vue&type=script&lang=js"
import style0 from "./bkInventInsuranceModal.vue?vue&type=style&index=0&id=5fbf4017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf4017",
  null
  
)

export default component.exports